module.exports = __webpack_public_path__ + "static/media/alignment-bg.ed8f3105.svg";